module.exports = __webpack_public_path__ + "static/YvonA-f21b84ea74032f08553541af9d95bad4.gif";